import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import ReactNativeSvg, { Circle } from 'react-native-svg';

import { scale } from '@components/frame';

import { ProgressIndicatorProps } from '@v2/context/ProductionBatch/types';

const ProgressIndicator: FC<ProgressIndicatorProps> = ({ progress, C }) => {
  const clampedProgress = Math.min(1, Math.max(0, progress));
  const radius = 50;
  const strokeWidth = 100;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - clampedProgress);

  const size = 14;
  const borderRadius = size / 2;

  return (
    <View
      style={{
        width: scale(size),
        height: scale(size),
        borderRadius: scale(borderRadius),
        borderWidth: StyleSheet.hairlineWidth,
        borderColor: C('Gray/Light/1'),
        padding: scale(1),
      }}
    >
      <View
        style={{
          width: '100%',
          height: '100%',
          borderRadius: scale(borderRadius),
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <ReactNativeSvg width="100%" height="100%" viewBox="0 0 100 100">
          <Circle
            cx="50"
            cy="50"
            r={radius}
            fill="transparent"
            stroke={C('Gray/Light/1')}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90, 50, 50)"
          />
        </ReactNativeSvg>
      </View>
    </View>
  );
};

export default ProgressIndicator;